import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-disponible-ticket-caisse',
  templateUrl: './disponible-ticket-caisse.component.html',
  styleUrls: ['./disponible-ticket-caisse.component.scss']
})
export class DisponibleTicketCaisseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
